import React from 'react'
import './Document2.css'

const Document2 = () => {
  return (
    <div id="stampArea">
      <div className='faith text-left'>Your Faithfully</div>
      <div className="divider mb-1" />
      <div className='d-flex justify-content-between'>
        <div className='text-left'>
          <div>Sign and Stamp</div>
          <div >Name:</div>
        </div>
        <div style={{ paddingRight: '15%' }}>
          <p>Date:</p>
        </div>
      </div>
    </div>
  )
}

export default React.memo(Document2);